import Component from './DeviceOperatorsGroup.vue';

export default Component;
